<template>
  <div v-if="messages.length">
    <div v-for="(alert, index) in messages" :key="`alert-${_uid}-${index}`">
      <ci-alert-item :closeable="true" :msg="alert.msg" :title="alert.title" :type="alert.type" @alert-item:close="onAlertClose(alert)" />
    </div>
  </div>
</template>

<script>
// components
import AlertItem from '@/components/alerts/AlertItem.vue';
import AwesomeIcon from '@/components/AwesomeIcon.vue';

export default {
  name: 'AlertMessages',

  components: {
    'ci-alert-item': AlertItem,
    'ci-awesome-icon': AwesomeIcon,
  },

  props: {
    autoClose: {
      type: Boolean,
      default: false,
      required: false,
    },

    messages: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },

  watch: {
    messages(newVal) {
      const filteredMessages = newVal.filter(message => !message.timeOut && message.autoClose);
      if (filteredMessages.length) {
        for (let i = 0; i < filteredMessages.length; i += 1) {
          const message = filteredMessages[i];
          Object.assign(message, {
            timeOut: true,
          });
          setTimeout(() => {
            const index = this.messages.indexOf(message);
            const newMessages = [];
            for (let a = 0; a < this.messages.length; a += 1) {
              if (a !== index) {
                newMessages.push(this.messages[a]);
              }
            }
            this.$emit('update:messages', newMessages);
          }, 5000);
        }
      }
    },
  },

  methods: {
    onAlertClose(alert) {
      const alertIndex = this.messages.indexOf(alert);
      const newMessages = [];
      for (let i = 0; i < this.messages.length; i += 1) {
        if (i !== alertIndex) {
          newMessages.push(this.messages[i]);
        }
      }
      this.$emit('update:messages', newMessages);
    },
  },
};
</script>

<style lang="scss">
.alert {
  .icon {
    opacity: 0.5;

    &:hover {
      cursor: pointer;
    }
  }
}

</style>
